import { Grid, styled } from "@mui/material";
import { IconCalendarMonth } from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import PropertyBuildingNameInput from "./BuildingNameInputField";
import BuildingManagementControls from "./BuildingManagementControls";
import BuildingDeliveryDateField from "./BuildingDeliveryDateField";

interface BuildingFormTableHeaderProps {}
const BuildingFormTableHeader = (props: BuildingFormTableHeaderProps) => {
  return (
    <Content container alignItems="center" gap={1}>
      <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
        <PropertyBuildingNameInput />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
        <BuildingManagementControls />
      </Grid>

      <Grid item flex={1} display={{ xs: "none", lg: "block" }} />

      <Grid item xs={"auto"}>
        <MxTypography variant="caption" color="white">
          Fecha de entrega
        </MxTypography>
      </Grid>

      <Grid item xs={"auto"}>
        <IconCalendarMonth />
      </Grid>
      <Grid item flex={1} display={{ xs: "block", md: "none" }} />
      <Grid item xs={6} sm={7} md={2} lg={2} xl={2}>
        <BuildingDeliveryDateField />
      </Grid>
    </Content>
  );
};

export default BuildingFormTableHeader;

const Content = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: "10px 10px 0 0",
  padding: "0.5rem 1rem"
}));
